import Chip from "@material-ui/core/Chip";
import * as React from "react";
import './ResultadoExportacao.scss'

interface IImportSellOutTableStatus {
  status: string;
}

function ResultadoExportcaoStatus({ status }: IImportSellOutTableStatus) {
  
    const getStatus = () => {
    switch (status) {
      case "PROCESSADO":
        return  <Chip label="Processado"  className="chip-processado"  />;
      case "PROCESSANDO":
        return  <Chip label="Processando" className="chip-processando" />;
      case "ERROR":
        return <Chip label="Erro" className="chip-error" />;
      case "Error":
          return <Chip label="Erro" className="chip-error" />;
      default:
        return <Chip label="Aguardando" className="chip-aguardando" />;
    }
  };
  return <div className="resultado-exportacao">{getStatus()}</div>;
}

export default ResultadoExportcaoStatus;


// WEBPACK FOOTER //
// ./src/component/shared/resultado-exportacao/ResultadoExportacaoStatus.tsx